import dayjs from 'dayjs';

export const birthDateConvertion = (date: string, isDevcode: boolean) => {
  const neededDate = new Date(date);
  const day = neededDate.getDate();
  const month = neededDate.getMonth() + 1;
  const year = neededDate.getFullYear();
  return !isDevcode ? `${day}.${month}.${year}` : dayjs(neededDate).format('YYYY-MM-DD');
};
